import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usage-agreement',
  templateUrl: './usage-agreement.component.html',
  styleUrls: ['./usage-agreement.component.css']
})
export class UsageAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
